import React from "react";
import AboutItem from "./AboutItem";
import cx from "classnames";
import styles from "./FeaturedAbout.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { aboutUsPage } from "@utils/helper";
import _ from "lodash";
import { OPPOSITE_POSITION } from "@utils/constant";
import Markdown from "@components/Markdown";

const COMPONENTS = {
  strong: ({ children }: any) => (
    <strong style={{ fontWeight: 405 }}>{children}</strong>
  ),
  ul: ({ children }: any) => (
    <div className="flex flex-col gap-6">{children}</div>
  ),
  li: ({ children }: any) => (
    <div className="flex">
      <div className="px-2">{`•`}</div>
      <div>{children}</div>
    </div>
  ),
};

export default function FeaturedAbout() {
  const { pageData } = usePageContext();
  const featuredAbout = aboutUsPage.formatFeaturedAbout(pageData);
  return (
    <div
      data-scroll-section
      className={cx("flex flex-col items-center", styles.featureAboutContainer)}
    >
      {_.map(featuredAbout, (item: any, index: number) => {
        const itemIndex = (index + 1) % 2 === 0 ? 2 : (index + 1) % 2;
        return (
          <>
            <AboutItem
              className={cx(styles[`item${itemIndex}`])}
              images={[
                {
                  ..._.get(item, "image"),
                  placement: _.get(item, "placement"),
                },
              ]}
              aside={{
                placement: OPPOSITE_POSITION[_.get(item, "placement")],
                className: cx(styles[`asideItem${itemIndex}`]),
                content: {
                  className: cx(styles[`contentItem${itemIndex}`]),
                  title: _.get(item, "title"),
                  text: (
                    <div className="flex flex-col mt-4 gap-7">
                      <Markdown
                        components={COMPONENTS}
                        content={_.get(item, "description")}
                      />
                    </div>
                  ),
                },
              }}
            />
          </>
        );
      })}
    </div>
  );
}
